<template>
  <div class="fa">
    <div
      :class="scroll_father == 'scroll-father' ? 'box' : 'box-small'"
      :style="
        feed == false
          ? 'border:1px solid #ccc;box-shadow: 0 0 30px 5px #ccc;border-radius:5px'
          : ''
      "
    >
      <div>
        <div :class="scroll_father" style="">
          <el-scrollbar wrapStyle="overflow-x:hidden;" style="height:100%">
            <el-divider content-position="left">
              <h2>资质信息</h2>
            </el-divider>
            <el-form
              label-width="150px"
              label-position="right"
              class="form-one"
            >
              <el-form-item label="店铺id：">
                {{ mch_id }}
              </el-form-item>
              <el-form-item v-if="feed" label="是否预授权：">
                <el-radio-group v-model="is_pre_auth">
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="2">否</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item v-else label="是否预授权：">
                {{ is_pre_auth == "1" ? "是" : "否" }}
              </el-form-item>

              <el-form-item label="店铺状态：">
                <el-select class="qualification-type-select" v-model="state">
                  <el-option
                    v-for="item in state_options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <!-- <el-form-item v-else label="店铺状态：">
                {{ getState() }}
              </el-form-item> -->
              <el-form-item v-show="feed" label="店铺密码：">
                <el-row>
                  <el-col :span="2">旧密码： </el-col>
                  <el-col :span="5"
                    ><el-input
                      v-model="pass_word"
                      show-password
                      style="width:150px;"
                    ></el-input
                  ></el-col>
                  <el-col :span="2">新密码：</el-col>
                  <el-col :span="5"
                    ><el-input
                      v-model="new_pass_word"
                      show-password
                      style="width:150px;"
                      placeholder="修改密码必填"
                    ></el-input
                  ></el-col>
                </el-row>
              </el-form-item>

              <el-form-item v-if="feed" label="店铺名称："
                ><el-input v-model="mch_name"></el-input
              ></el-form-item>
              <el-form-item v-else label="店铺名称：">{{
                mch_name
              }}</el-form-item>

              <el-form-item v-if="feed" label="店铺简称："
                ><el-input v-model="sub_name"></el-input
              ></el-form-item>

              <el-form-item v-else label="店铺简称：">{{
                sub_name
              }}</el-form-item>

              <el-form-item label="资质类型：">
                {{ mch_type_name }}
              </el-form-item>
              <el-form-item label="经营范围：">
                <el-select
                  v-model="business_scope"
                  filterable
                  placeholder="经营范围(可搜索)"
                >
                  <el-option
                    v-for="item in MCC"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <!-- <el-form-item v-else label="经营范围：">
                {{ getScope() }}
              </el-form-item> -->
              <el-form-item label="营业执照照片：">
                <img
                  style="width:220px;height:300px"
                  :src="
                    img_license
                      ? $url + 'media/image/' + img_license + '.jpg'
                      : ''
                  "
                  alt="营业执照照片加载失败"
                />

                <!-- <uploadImg
                  class="uploadImg"
                  :imgTitle="'yyzz'"
                  @getReturn="getReturn"
                  @removeImg="removeImg"
                >
                  <template slot="centerName">
                    营业执照
                  </template>
                </uploadImg> -->
              </el-form-item>
              <el-form-item label="营业执照id：">{{
                license_code
              }}</el-form-item>
              <el-form-item label="营业执照有效期：">
                <el-col :span="6">
                  <!--  <el-date-picker
                    type="date"
                    placeholder="开始日期"
                    v-model="license_start_date"
                    style="width: 100%;"
                    @change="getDate($event, 'license_start_date')"
                  ></el-date-picker> -->
                  {{ license_start_date }}
                </el-col>
                <el-col :span="1">&nbsp;&nbsp;</el-col>
                <el-col :span="6">
                  <!-- <el-date-picker
                    type="date"
                    placeholder="截止日期(长期则不选)"
                    v-model="license_expire_in"
                    @change="getDate($event, 'license_expire_in')"
                    style="width: 100%;"
                  ></el-date-picker> -->
                  {{ license_expire_in }}
                </el-col>
              </el-form-item>
              <el-form-item label="店铺省市区：">
                <el-cascader
                  v-model="address_code"
                  class="qualification-type-select"
                  :options="provincearr"
                  @change="shophandleChange"
                  :filterable="true"
                  :clearable="true"
                  disabled
                ></el-cascader>
              </el-form-item>
              <!-- <el-form-item label="店铺地址：">{{ address }}</el-form-item> -->
              <el-form-item v-if="feed" label="店铺地址："
                ><el-input v-model="address"></el-input
              ></el-form-item>

              <el-form-item v-else label="店铺地址：">{{
                adderss
              }}</el-form-item>
              <el-form-item label="店铺门头照：">
                <img
                  style="width:300px;height:220px"
                  :src="
                    img_door ? $url + 'media/image/' + img_door + '.jpg' : ''
                  "
                  alt="店门头图片加载失败"
                />
              </el-form-item>

              <el-form-item label="店铺内景照片：">
                <img
                  style="width:300px;height:220px"
                  :src="
                    img_in_door
                      ? $url + 'media/image/' + img_in_door + '.jpg'
                      : ''
                  "
                  alt="店铺内景照片加载失败"
                />
              </el-form-item>
              <el-form-item label="收银台照片：">
                <img
                  style="width:300px;height:220px"
                  :src="
                    img_cashier
                      ? $url + 'media/image/' + img_cashier + '.jpg'
                      : ''
                  "
                  alt="收银台照片加载失败"
                />
              </el-form-item>
            </el-form>
            <el-divider content-position="left">
              <h2>基础信息</h2>
            </el-divider>
            <el-form
              label-width="150px"
              label-position="right"
              ref="wxFormRef"
              class="form-two"
            >
              <el-form-item label="法人姓名：">{{
                legal_person_name
              }}</el-form-item>
              <el-form-item label="法人身份证号：">{{
                legal_person_id
              }}</el-form-item>

              <el-form-item label="法人身份证有效期：">
                {{ legal_person_id_start_date }} -
                {{ legal_person_id_expire_in }}
              </el-form-item>

              <el-form-item label="法人身份证：">
                <img
                  style="width:300px;height:220px"
                  :src="
                    img_legal_id_front
                      ? $url + 'media/image/' + img_legal_id_front + '.jpg'
                      : ''
                  "
                  alt="法人身份证正面图片加载失败"
                />
                <img
                  style="width:300px;height:220px; margin-left:20px"
                  :src="
                    img_legal_id_back
                      ? $url + 'media/image/' + img_legal_id_back + '.jpg'
                      : ''
                  "
                  alt="法人身份证反面图片加载失败"
                />
              </el-form-item>

              <el-form-item label="联系人："
                ><el-input
                  v-model="contact_man"
                  placeholder="一般填业务员的姓名"
                ></el-input
              ></el-form-item>
              <!-- <el-form-item v-else label="联系人：">
                {{ contact_man }}
              </el-form-item>
 -->
              <el-form-item label="联系人手机号："
                ><el-input
                  v-model="mobile_no"
                  placeholder="一般填业务员的手机号码"
                ></el-input
              ></el-form-item>
              <!-- <el-form-item v-else label="联系人手机号：">{{
                mobile_no
              }}</el-form-item> -->

              <el-form-item v-if="feed" label="店铺电话："
                ><el-input
                  v-model="phone"
                  placeholder="需填写店铺负责人的手机号码"
                ></el-input
              ></el-form-item>
              <el-form-item v-else label="店铺电话：">{{ phone }}</el-form-item>

              <el-form-item label="服务电话："
                ><el-input
                  v-model="service_phone"
                  placeholder="填写店铺的客服电话"
                ></el-input
              ></el-form-item>
              <!-- <el-form-item v-else label="服务电话：">{{
                service_phone
              }}</el-form-item> -->

              <el-form-item label="店铺传真："
                ><el-input v-model="fax" placeholder="店铺传真"></el-input>
              </el-form-item>
              <!-- <el-form-item v-else label="店铺传真：">{{ fax }} </el-form-item> -->

              <el-form-item label="店铺邮箱："
                ><el-input
                  v-model="e_mail"
                  placeholder="店铺电子邮箱"
                ></el-input
              ></el-form-item>
              <!-- <el-form-item v-else label="店铺邮箱：">
                {{ e_mail }}
              </el-form-item> -->
            </el-form>
            <el-divider content-position="left">
              <h2>结算信息</h2>
            </el-divider>
            <el-form
              label-width="150px"
              label-position="right："
              ref="wxFormRef"
              class="form-three"
            >
              <el-form-item label="开户银行卡照片：">
                <uploadImg
                  class="uploadImg"
                  :imgTitle="'bank'"
                  :removeS="false"
                  @getReturn="getReturn"
                  @removeImg="removeImg"
                  :imgsrc="
                    img_bank_card
                      ? $url + 'media/image/' + img_bank_card + '.jpg'
                      : ''
                  "
                >
                  <template slot="centerName">
                    银行卡
                  </template>
                </uploadImg>
              </el-form-item>

              <el-form-item label="结算银行卡号："
                ><el-input
                  v-model="account_code"
                  placeholder="填写结算银行银行卡账号"
                ></el-input
              ></el-form-item>
              <el-form-item label="银行卡账号名称："
                ><el-input
                  v-model="account_name"
                  placeholder="填写结算银行卡的账号名称"
                ></el-input
              ></el-form-item>
              <el-form-item label="银行名称：">
                <el-select
                  v-model="bank_name"
                  filterable
                  placeholder="开户银行名称"
                >
                  <el-option
                    v-for="item in bank_name_options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.label"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="开户银行省市：">
                <el-row>
                  <el-col :span="6">
                    <div id="bank_select">
                      <el-select
                        v-model="bank_province"
                        filterable
                        placeholder="选择省"
                        @change="getCity"
                      >
                        <el-option
                          v-for="item in province_option"
                          :key="item.value"
                          :label="item.label"
                          :value="item.label"
                        >
                        </el-option>
                      </el-select>
                    </div>
                  </el-col>
                  <el-col :span="5"></el-col>
                  <el-col :span="6">
                    <div id="bank_select">
                      <el-select
                        v-model="bank_city"
                        filterable
                        placeholder="选择市"
                        style="width:200px"
                        @change="getOpenBank"
                      >
                        <el-option
                          v-for="item in city_option"
                          :key="item.value"
                          :label="item.label"
                          :value="item.label"
                        >
                        </el-option>
                      </el-select>
                    </div>
                  </el-col>
                </el-row>
                <i style="color:rgb(113, 113, 113)"
                  >选择银行名称之后选择省再选择市,开户银行名称就会有提示</i
                >
              </el-form-item>
              <el-form-item label="开户银行名称：">
                <el-select
                  v-model="open_bank_name"
                  filterable
                  placeholder="选择开户行支行"
                  style="width:200px"
                  @change="getOpenBnakName"
                >
                  <!-- @change="" -->
                  <el-option
                    v-for="item in open_bank_options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.label"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item v-if="!feed" label="服务费率：">
                <el-input
                  v-model="service_charge"
                  placeholder=""
                  max="0.6"
                  min="0.2"
                  maxlength="5"
                ></el-input>
              </el-form-item>
              <!-- <el-form-item label="服务费率：">
                {{ service_charge }}
              </el-form-item> -->
              <el-form-item label="受益人为法人：">
                <el-radio-group v-model="wxradio">
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="2">否</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item v-show="wxradio == '2'" label="受益人身份证：">
                <el-row>
                  <el-col :span="9">
                    <uploadImg
                      class="uploadImg"
                      :imgTitle="'beneficiary_zm'"
                      :removeS="false"
                      @getReturn="getReturn"
                      @removeImg="removeImg"
                      style="display:inline-block"
                      :imgsrc="
                        img_beneficiary_id_front
                          ? $url +
                            'media/image/' +
                            img_beneficiary_id_front +
                            '.jpg'
                          : ''
                      "
                    >
                      <template slot="centerName">
                        受益人身份证正面
                      </template>
                    </uploadImg>
                  </el-col>
                  <el-col :span="7">
                    <uploadImg
                      class="uploadImg"
                      :removeS="false"
                      :imgTitle="'beneficiary_fm'"
                      @getReturn="getReturn"
                      @removeImg="removeImg"
                      style="display:inline-block;"
                      :imgsrc="
                        img_beneficiary_id_back
                          ? $url +
                            'media/image/' +
                            img_beneficiary_id_back +
                            '.jpg'
                          : ''
                      "
                    >
                      <template slot="centerName">
                        受益人身份证反面
                      </template>
                    </uploadImg>
                  </el-col>
                </el-row>
              </el-form-item>

              <el-form-item v-show="wxradio == '1'" label="受益人身份证：">
                <img
                  style="width:300px;height:220px"
                  :src="
                    img_beneficiary_id_front
                      ? $url +
                        'media/image/' +
                        img_beneficiary_id_front +
                        '.jpg'
                      : ''
                  "
                  alt="法人身份证正面图片加载失败"
                />
                <img
                  style="width:300px;height:220px; margin-left:20px"
                  :src="
                    img_beneficiary_id_back
                      ? $url + 'media/image/' + img_beneficiary_id_back + '.jpg'
                      : ''
                  "
                  alt="法人身份证反面图片加载失败"
                />
              </el-form-item>
              <el-form-item label="受益人姓名：">
                <el-input
                  :disabled="wxradio == '1'"
                  v-model="beneficiary_name"
                ></el-input>
              </el-form-item>
              <el-form-item label="受益人身份证号：">
                <el-input
                  :disabled="wxradio == '1'"
                  v-model="beneficiary_id"
                ></el-input>
              </el-form-item>
              <el-form-item label="受益人身份证有效期：">
                <el-col :span="6">
                  <el-date-picker
                    :disabled="wxradio == '1'"
                    type="date"
                    placeholder="开始日期"
                    v-model="beneficiary_id_start_date"
                    style="width: 100%;"
                    @change="getDate($event, 'beneficiary_id_start_date')"
                  ></el-date-picker>
                </el-col>
                <el-col :span="1">&nbsp;&nbsp;</el-col>
                <el-col :span="6">
                  <el-date-picker
                    type="date"
                    :disabled="wxradio == '1'"
                    placeholder="截止日期(长期则不选)"
                    v-model="beneficiary_id_expire_in"
                    @change="getDate($event, 'beneficiary_id_expire_in')"
                    style="width: 100%;"
                  ></el-date-picker>
                </el-col>
              </el-form-item>

              <el-form-item v-if="wxradio == '2'" label="授权书：">
                <uploadImg
                  class="uploadImg"
                  :removeS="false"
                  :imgTitle="'warrant'"
                  @getReturn="getReturn"
                  @removeImg="removeImg"
                  :imgsrc="
                    img_warrant
                      ? $url + 'media/image/' + img_warrant + '.jpg'
                      : ''
                  "
                >
                  <template slot="centerName">
                    授权书
                  </template>
                </uploadImg>
              </el-form-item>
            </el-form>
          </el-scrollbar>
        </div>
      </div>
      <div
        :class="
          scroll_father == 'scroll-father'
            ? 'button-bottom'
            : 'button-bottom-small'
        "
      >
        <!-- :size="scroll_father == 'scroll-father-small' ? 'small' : ''" -->
        <el-button size="small" plain type="primary" @click="submitInfo"
          >保存更改</el-button
        >
        <el-button
          v-if="feed == false"
          size="small"
          plain
          type="danger"
          @click="closeMorf"
          >关闭</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
/* import {
  GetBankProvince,
  GetBankcity,
  GetBankCode,
  merchantQuery,
  queryMerchant,
  merchantModify,
  ModifyMerchant,
  GetMrchantAesKey
} from "@/api/index"; */
import uploadImg from "../components/uploadImg.vue";
import { province, map } from "../js/map";
import { MCC } from "../js/MCC";
let pinyin = require("js-pinyin");
export default {
  name: "morf",
  components: { uploadImg },
  async created() {
    this.provincearr = province;
    this.map = map;
    this.MCC = MCC;
    var { data: res } = await GetBankProvince();
    for (var i = 0; i < res.resp_data.length; i++) {
      this.province_option.push({
        label: res.resp_data[i],
        value: i
      });
    }
  },
  async mounted() {
    var that = this;
    var resolution = localStorage.getItem("pixel");
    if (resolution <= 1400 * 900) {
      this.scroll_father = "scroll-father-small";
    }
    if (resolution > 1400 * 900) {
      this.scroll_father = "scroll-father";
    }
    console.log("true:为 店铺 false：为服务商", this.feed);

    if (this.feed) {
      var data = {
        access_token: localStorage.getItem("access_token")
      };
      this.$nextTick(function() {
        merchantQuery(data).then(async ({ data: res }) => {
          GetMrchantAesKey().then(({ data: resk }) => {
            if (res.resp_data.legal_person_id) {
              res.resp_data.legal_person_id = that.Decrypt(
                res.resp_data.legal_person_id,
                resk.resp_data.aes_key
              );
            }
            if (res.resp_data.beneficiary_id) {
              res.resp_data.beneficiary_id = that.Decrypt(
                res.resp_data.beneficiary_id,
                resk.resp_data.aes_key
              );
            }
            if (res.resp_data.mobile_no) {
              res.resp_data.mobile_no = that.Decrypt(
                res.resp_data.mobile_no,
                resk.resp_data.aes_key
              );
            }
            console.log("解密mobile_no：", res.resp_data.mobile_no);
            console.log("密钥：", resk.resp_data.aes_key);

            for (var key in res.resp_data) {
              if (key == "is_pre_auth") {
                this[key] = Number(res.resp_data[key]);
              } else if (key == "mch_type") {
                for (var i = 0; i < this.mch_type_options.length; i++) {
                  if (
                    this.mch_type_options[i].value == String(res.resp_data[key])
                  );
                  this.mch_type_name = this.mch_type_options[i].label;
                }
              } else if (key == "state") {
                this[key] = Number(res.resp_data[key]);
              } else if (key == "beneficiary_id_expire_in") {
                this.beneficiary_id_expire_in = res.resp_data[key];
              } else {
                this[key] = res.resp_data[key];
              }
            }
          });
          console.log(res.resp_data);
        });
      });

      //
    } else {
      var data = {
        merchant_id: this.mch_id,
        access_token: localStorage.getItem("access_token")
      };
      var { data: res } = await queryMerchant(data);
      for (var key in res.resp_data) {
        if (key == "is_pre_auth") {
          this[key] = Number(res.resp_data[key]);
        } else if (key == "mch_type") {
          for (var i = 0; i < this.mch_type_options.length; i++) {
            if (this.mch_type_options[i].value == String(res.resp_data[key]));
            this.mch_type_name = this.mch_type_options[i].label;
          }
        } else if (key == "state") {
          this[key] = Number(res.resp_data[key]);
        } else if (key == "beneficiary_id_expire_in") {
          this.beneficiary_id_expire_in = res.resp_data[key];
        } else {
          this[key] = res.resp_data[key];
        }
      }
    }
  },
  beforeDestroy() {},
  data() {
    return {
      //商户简称
      sub_name: "",
      new_pass_word: "",
      scroll_father: "",
      //省市区编号
      address_code: "",
      /// 店铺密码
      pass_word: localStorage.getItem("mch_pw"),
      /// 店铺全名称 优选易购生活超市-颐和店
      mch_name: "",
      /* /// 店铺简称 优选易购颐和店
      sub_name: "",
      /// 店铺全称的拼音首字符
      pym: "", */
      /// 营业执照ID
      license_code: "",
      /// 法人姓名
      legal_person_name: "",
      /// 法人身份证号
      legal_person_id: "",
      /// 联系人 日常联系人通常是业务员
      contact_man: "",
      /// 联系人的手机号码
      mobile_no: "",
      /// 店铺地址
      address: "",
      /// 店铺电话
      phone: "",
      /// 服务电话 给用户联系的电话展示在店铺中
      service_phone: "",
      /// 传真
      fax: "",
      /// 电子邮箱
      e_mail: "",
      /// 结算银行卡的账号名称
      account_name: "",
      /// 结算账号
      account_code: "",
      //开户银行
      bank_name: "",
      //开户银行名称含支行
      open_bank_name: "",
      ///银行卡
      img_bank_card: "",
      ///门头照
      img_door: "",
      //内景
      img_in_door: "",
      //收银台
      img_cashier: "",
      //授权书
      img_warrant: "",
      /// 法人身份证正面人像面
      img_legal_id_front: "",
      /// 法人身份证反面
      img_legal_id_back: "",
      /// 营业执照照片
      img_license: "",
      //受益人
      beneficiary_id: "",
      beneficiary_name: "",
      img_beneficiary_id_front: "",
      img_beneficiary_id_back: "",
      beneficiary_id_start_date: "",
      beneficiary_id_expire_in: "",
      //商铺类型
      mch_type: "",
      mch_type_name: "",
      mch_type_options: [
        { label: "自然人", value: "1" },
        { label: "个体户", value: "2" },
        { label: "企业", value: "3" }
      ],
      //经营范围
      business_scope: "",
      //营业执照开始有效期
      license_start_date: "",
      //营业执照结束有效期
      license_expire_in: "",

      //法人身份证开始有效期
      legal_person_id_start_date: "",
      //法人身份证结束有效期
      legal_person_id_expire_in: "",

      //服务费率
      service_charge: "",
      //是否预授权
      is_pre_auth: 0,
      //操作时间
      oper_date: "",

      sure: true, //是否确定提交
      active: 1,
      wxradio: 1,
      map: [],
      MCC: [],
      address_name: "",
      nonce_str: "",
      bank_name_options: [
        { value: "1", label: "中国农业发展银行" },
        { value: "2", label: "其他银行" },
        { value: "3", label: "广发银行" },
        { value: "4", label: "村镇银行" },
        { value: "5", label: "上海浦东发展银行" },
        { value: "6", label: "中国农业银行" },
        { value: "7", label: "渤海银行" },
        { value: "8", label: "中国工商银行" },
        { value: "9", label: "中国银行" },
        { value: "10", label: "华夏银行" },
        { value: "11", label: "中国民生银行" },
        { value: "12", label: "平安银行" },
        { value: "13", label: "中国人民银行" },
        { value: "14", label: "交通银行" },
        { value: "15", label: "中国建设银行" },
        { value: "16", label: "招商银行" },
        { value: "17", label: "城市商业银行" },
        { value: "18", label: "中国邮政储蓄银行" },
        { value: "19", label: "中信银行" },
        { value: "20", label: "农村商业银行" },
        { value: "21", label: "兴业银行" },
        { value: "22", label: "中国光大银行" },
        { value: "23", label: "浙商银行" }
      ],
      city_option: [],
      province_option: [],
      bank_province: "",
      bank_city: "",
      open_bank_options: [],
      //开户行银联号
      open_bank_code: "",
      bank_name_value: "",
      state_options: [
        { value: -1, label: "店铺关停" },
        { value: 0, label: "店铺正常营业" },
        { value: 1, label: "店铺暂停营业" }
      ],
      state: ""
    };
  },
  props: {
    feed: Boolean,
    mch_id: String
  },
  methods: {
    getOpenBnakName() {
      for (var i = 0; i < this.open_bank_options.length; i++) {
        if (this.open_bank_options[i].label == this.open_bank_name) {
          this.open_bank_code = this.open_bank_options[i].value;
        }
      }
    },
    getState() {
      switch (this.state) {
        case -1:
          return "店铺关停";
        case 0:
          return "店铺正常营业";
        case 1:
          return "店铺暂停营业";
        case 2:
          return "未知";
      }
    },
    getScope() {
      var that = this;
      var a = "";
      this.MCC.forEach(function(item) {
        if (item.value === that.business_scope) a = item.label;
      });
      return a;
    },
    async shophandleChange(e) {
      if (e.length == 0) {
        return;
      }
      this.address_code = e[2];
      this.address_name = this.map[e[2]];
    },
    removeImg(imgTitle) {
      switch (imgTitle) {
        case "fm":
          this.img_legal_id_back = "";
          break;
        case "zm":
          this.img_legal_id_front = "";
          break;
        case "yyzz":
          this.img_license = "";
          break;
        case "bank":
          this.img_bank_card = "";
          break;
        case "indoor":
          this.img_in_door = "";
          break;
        case "cashier":
          this.img_cashier = "";
          break;
        case "store_entrance":
          this.img_door = "";
          break;
        case "warrant":
          this.img_warrant = "";
          break;
        case "beneficiary_zm":
          this.img_beneficiary_id_front = "";
          break;
        case "beneficiary_fm":
          this.img_beneficiary_id_back = "";
          break;
      }
    },
    async getOpenBank() {
      var data = {
        province: this.bank_province,
        city: this.bank_city
      };
      var { data: res } = await GetBankCode(JSON.stringify(data));
      console.log("返回值", res);
      if (res.resp_data.length > 0) {
        var arr = res.resp_data;
        this.open_bank_options = [];
        if (this.bank_name == "其他银行") {
          for (var i = 0; i < arr.length; i++) {
            this.open_bank_options.push({
              label: arr[i].full_name,
              value: arr[i].bank_code
            });
          }
        } else {
          for (var x in arr) {
            if (arr[x].full_name.indexOf(this.bank_name) >= 0) {
              this.open_bank_options.push({
                label: arr[x].full_name,
                value: arr[x].bank_code
              });
            }
          }
        }
      }
    },
    async getCity() {
      this.city_option = [];
      var { data: res } = await GetBankcity(this.bank_province);
      for (var i = 0; i < res.resp_data.length; i++) {
        this.city_option.push({
          label: res.resp_data[i],
          value: i
        });
      }
    },
    getDate(date, e) {
      if (date == null) {
        return;
      }
      var datearr = date.toDateString().split(" ");
      switch (datearr[1]) {
        case "Jan":
          this[e] = datearr[3] + "-01-" + datearr[2];
          break;
        case "Feb":
          this[e] = datearr[3] + "-02-" + datearr[2];
          break;
        case "Mar":
          this[e] = datearr[3] + "-03-" + datearr[2];
          break;
        case "Apr":
          this[e] = datearr[3] + "-04-" + datearr[2];
          break;
        case "May":
          this[e] = datearr[3] + "-05-" + datearr[2];
          break;
        case "Jun":
          this[e] = datearr[3] + "-06-" + datearr[2];
          break;
        case "Jul":
          this[e] = datearr[3] + "-07-" + datearr[2];
          break;
        case "Aug":
          this[e] = datearr[3] + "-08-" + datearr[2];
          break;
        case "Sep":
          this[e] = datearr[3] + "-09-" + datearr[2];
          break;
        case "Oct":
          this[e] = datearr[3] + "-10-" + datearr[2];
          break;
        case "Nov":
          this[e] = datearr[3] + "-11-" + datearr[2];
          break;
        case "Dec":
          this[e] = datearr[3] + "-12-" + datearr[2];
          break;
      }
    },
    getReturn(res) {
      switch (res.title) {
        case "beneficiary_zm":
          if (res.img) {
            this.img_beneficiary_id_front = res.img;
          }
          if (res.img_info) {
            // console.log("受益人身份证正面：",res.img_info)
            this.beneficiary_name = res.img_info.name;
            this.beneficiary_id = res.img_info.number;
          } else {
            this.warnMessage("受益人身份证正面上传失败，请重试");
          }
          break;
        case "zm":
          if (res.img_info) {
            /* this.legal_person_card = res.info;
            this.legal_person_name = res.info;
            this.contact_man = res.info; */
            this.legal_person_name = res.img_info.name;
            this.legal_person_id = res.img_info.number;
          }
          if (res.imgstr) {
            this.legal_person_img_font = res.imgstr;
          }
          break;
        case "beneficiary_fm":
          if (res.img) {
            this.img_beneficiary_id_back = res.img;
          }
          if (res.img_info) {
            this.beneficiary_id_start_date = res.img_info.begin;
            this.beneficiary_id_expire_in = res.img_info.end;
          } else {
            this.warnMessage("受益人身份证反面上传失败，请重试");
          }
          break;
        case "fm":
          if (res.img_info) {
            this.legal_person_id_start_date = res.img_info.begin;
            this.legal_person_id_expire_in = res.img_info.end;
          }
          if (res.imgstr) {
            this.legal_person_img_back = res.imgurl;
          }
          break;
        case "bank":
          if (res.img_info) {
            this.account_code = res.img_info.number;
          }
          if (res.imgstr) {
            this.bank_img = res.imgstr; //银行卡照片
          }
          break;
      }
    },
    // 提交信息
    async submitInfo() {
      this.getDate(new Date(), "oper_date");
      this.nonce_str = this.getKey();
      const access_token = localStorage.getItem("access_token");
      if (this.feed) {
        console.log(this.feed);
        var object = {
          nonce_str: this.nonce_str,
          access_token: access_token,
          mch: {
            pass_word: this.pass_word,
            mch_name: this.mch_name,
            license_code: this.license_code,
            contact_man: this.contact_man,
            mobile_no: this.mobile_no,
            address: this.address,
            phone: this.phone,
            service_phone: this.service_phone,
            fax: this.fax,
            sub_name: this.sub_name,
            e_mail: this.e_mail,
            account_name: this.account_name,
            account_code: this.account_code,
            bank_name: this.bank_name,
            open_bank_name: this.open_bank_name,
            open_bank_code: this.open_bank_code,
            img_bank_card: this.img_bank_card,
            img_door: this.img_door,
            img_in_door: this.img_in_door,
            img_cashier: this.img_cashier,
            img_warrant: this.img_warrant,
            img_license: this.img_license,
            beneficiary_id: this.beneficiary_id,
            beneficiary_name: this.beneficiary_name,
            img_beneficiary_id_front: this.img_beneficiary_id_front,
            img_beneficiary_id_back: this.img_beneficiary_id_back,
            is_pre_auth: this.is_pre_auth,
            oper_date: this.oper_date,
            business_scope: this.business_scope,
            license_start_date: this.license_start_date,
            license_expire_in: this.license_expire_in,
            mch_type: this.mch_type,
            beneficiary_id_start_date: this.beneficiary_id_start_date,
            beneficiary_id_expire_in: this.beneficiary_id_expire_in,
            address_code: this.address_code,
            state: this.state
          }
        };
        if (this.new_pass_word) object.mch.new_pass_word = this.new_pass_word;
        var sign = this.getSign(object);
        var data = {
          nonce_str: this.nonce_str,
          access_token: access_token,
          sign: sign,
          mch: {
            pass_word: await this.encrypt(this.pass_word),
            mch_name: this.mch_name,
            license_code: this.license_code,
            contact_man: this.contact_man,
            mobile_no: await this.encrypt(this.mobile_no),
            address: this.address,
            phone: this.phone,
            service_phone: this.service_phone,
            fax: this.fax,
            sub_name: this.sub_name,
            e_mail: this.e_mail,
            account_name: this.account_name,
            account_code: this.account_code,
            bank_name: this.bank_name,
            open_bank_name: this.open_bank_name,
            open_bank_code: this.open_bank_code,
            img_bank_card: this.img_bank_card,
            img_door: this.img_door,
            img_in_door: this.img_in_door,
            img_cashier: this.img_cashier,
            img_warrant: this.img_warrant,
            img_license: this.img_license,
            beneficiary_id: await this.encrypt(this.beneficiary_id),
            beneficiary_name: this.beneficiary_name,
            img_beneficiary_id_front: this.img_beneficiary_id_front,
            img_beneficiary_id_back: this.img_beneficiary_id_back,
            is_pre_auth: this.is_pre_auth,
            oper_date: this.oper_date,
            business_scope: this.business_scope,
            license_start_date: this.license_start_date,
            license_expire_in: this.license_expire_in,
            mch_type: this.mch_type,
            beneficiary_id_start_date: this.beneficiary_id_start_date,
            beneficiary_id_expire_in: this.beneficiary_id_expire_in,
            address_code: this.address_code,
            state: this.state
          }
        };
        //await this.encrypt(this.beneficiary_id)
        if (this.new_pass_word)
          data.mch.new_pass_word = await this.encrypt(this.new_pass_word);
      } else {
        let object = {
          nonce_str: this.nonce_str,
          access_token: access_token,
          service_id: localStorage.getItem("service_id"),
          merchant_id: this.mch_id,
          mch: {
            mobile_no: this.mobile_no,
            service_phone: this.service_phone,
            fax: this.fax,
            e_mail: this.e_mail,
            service_charge: this.service_charge,
            contact_man: this.contact_man,
            account_name: this.account_name,
            account_code: this.account_code,
            bank_name: this.bank_name,
            open_bank_name: this.open_bank_name,
            open_bank_code: this.open_bank_code,
            img_bank_card: this.img_bank_card,
            img_warrant: this.img_warrant,
            beneficiary_id: this.beneficiary_id,
            beneficiary_name: this.beneficiary_name,
            img_beneficiary_id_front: this.img_beneficiary_id_front,
            img_beneficiary_id_back: this.img_beneficiary_id_back,
            beneficiary_id_start_date: this.beneficiary_id_start_date,
            beneficiary_id_expire_in: this.beneficiary_id_expire_in,
            state: this.state,
            business_scope: this.business_scope
          }
        };
        var sign = this.getSign(object);
        var data = {
          nonce_str: this.nonce_str,
          access_token: access_token,
          service_id: localStorage.getItem("service_id"),
          merchant_id: this.mch_id,
          sign: sign,
          mch: {
            mobile_no: this.mobile_no,
            service_phone: this.service_phone,
            fax: this.fax,
            e_mail: this.e_mail,
            service_charge: this.service_charge,
            contact_man: this.contact_man,
            account_name: this.account_name,
            account_code: this.account_code,
            bank_name: this.bank_name,
            business_scope: this.business_scope,
            open_bank_name: this.open_bank_name,
            open_bank_code: this.open_bank_code,
            img_bank_card: this.img_bank_card,
            img_warrant: this.img_warrant,
            beneficiary_id: this.beneficiary_id,
            beneficiary_name: this.beneficiary_name,
            img_beneficiary_id_front: this.img_beneficiary_id_front,
            img_beneficiary_id_back: this.img_beneficiary_id_back,
            beneficiary_id_start_date: this.beneficiary_id_start_date,
            beneficiary_id_expire_in: this.beneficiary_id_expire_in,
            state: this.state
          }
        };
      }
      if (this.feed) {
        console.log(JSON.stringify(data));
        var { data: res } = await merchantModify(JSON.stringify(data));
        console.log("店铺修改", res);
        if (res.return_code == "FAIL" || res.return_msg) {
          this.$message.error(res.return_msg);
          return;
        } else if (res.result_code == "FAIL" || res.result_msg) {
          this.$message.error(res.result_msg);
          return;
        } else if (
          res.result_code == "SUCCESS" &&
          res.return_code == "SUCCESS" &&
          res.resp_data
        ) {
          this.successMessage("修改成功");
        }
      } else {
        console.log(JSON.stringify(data));
        var res = await ModifyMerchant(JSON.stringify(data));
        console.log("修改qqqqqqqqqqqqq", res);
      }
      console.log("法人id：", await this.encrypt(this.legal_person_id));
    },
    closeMorf() {
      this.$emit("colse-morf", "");
    }
  }
};
</script>
<style scoped>

.scroll-father {
  height: 620px;
  margin-top: 40px;
}
.scroll-father-small {
  height: 550px;
  margin-top: 60px;
}
.el-form-item >>> .el-input {
  width: 460px;
}
.button-bottom-small {
  position: absolute;
  /* bottom: 30px; */
  left: 50%;
  transform: translate(-50%, 0);
  display: flex;
  justify-content: space-between;
}
.button-bottom {
  position: absolute;
  bottom: 1px;
  left: 50%;
  transform: translate(-50%, 0);
  display: flex;
  justify-content: space-between;
}
h2 {
  margin: 0;
  padding: 0;
}
#bank_select >>> .el-input {
  width: 150px !important;
}
.box {
  position: absolute;
  width: 962px;
  height: 702px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin-top: -20px;
  background-color: #fff !important;
}
.box-small {
  position: absolute;
  width: 962px;
  height: 650px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin-top: -20px;
  background-color: #fff !important;
}
img {
  font-size: 20px;
  color: rgb(175, 26, 26);
}
.el-form-item {
  color: rgb(113, 113, 113);
}
</style>
